import { Global } from "constants/global";

export const redirectToHome = () => {
    window.location.href = Global.homeUrl;
};